/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line
  // Last Sync: 2026-01-27 12:05:00

  /**
   * Store Slider: Click to advance
   * Clicking anywhere on the slider (excluding navigation dots) will advance to the next slide.
   * Includes automatic wrap-around (rewind) when the last slide is reached.
   */
  document.addEventListener('click', function (e) {
    const slideItem = e.target.closest('[data-section-type="store-slider"] [data-slide]');
    const isDot = e.target.closest('.flickity-page-dots');

    if (slideItem && !isDot) {
      const slideshow = slideItem.closest('slideshow-component');
      if (slideshow && slideshow.flkty) {
        slideshow.flkty.next(true); // true = wrap around (rewind)
      }
    }
  });

  /**
   * Product Grid: "+X more" trigger
   * Clicking the "+X más" button on a product card triggers its native Quick View modal.
   */
  document.addEventListener('click', function (e) {
    const moreTrigger = e.target.closest('.js-quick-buy-trigger');
    if (moreTrigger) {
      e.preventDefault();
      const productGridItem = moreTrigger.closest('.product-grid-item');
      if (productGridItem) {
        // Palo Alto uses [data-button-quick-view] for the Quick View trigger
        const quickViewButton = productGridItem.querySelector('[data-button-quick-view]');
        if (quickViewButton) {
          quickViewButton.click();
        }
      }
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
